import { render, staticRenderFns } from "./InvestView.vue?vue&type=template&id=7903ecbe&"
import script from "./InvestView.vue?vue&type=script&lang=js&"
export * from "./InvestView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports